// NOTE The elements for this module to be inside the Vue instance because they both contain the
// header-search vue component. If this proves problematic then this module may need to be
// refactored to use Vue event handling instead of native.

import throttle from 'lodash/throttle';

export default function init() {
  const mobileNavContainer = document.querySelector<HTMLElement>('.js-mobile-nav-fixed-container');
  const headerIntersector = document.querySelector<HTMLElement>('.js-header-intersector')!;

  let isMenuOpen = false; // Add state tracking variable

  function initFeatureHeroObserver() {
    let lastScrollY = window.scrollY;
    let isAboveIntersector = false;

    // Pre-cache class lists and attributes for better performance
    const classes = {
      hide: ['-translate-y-full', 'true'],
      show: ['-translate-y-0', 'false'],
    };

    function updateHeaderClasses(shouldHide: boolean) {
      if (isMenuOpen) return;

      const [translateClass] = shouldHide ? classes.hide : classes.show;
      const [removeTranslateClass] = shouldHide ? classes.show : classes.hide;

      mobileNavContainer?.classList.remove(removeTranslateClass);
      mobileNavContainer?.classList.add(translateClass);
      mobileNavContainer?.toggleAttribute('inert', shouldHide);
    }

    const handleScroll = throttle(() => {
      const currentScrollY = window.scrollY;
      if (currentScrollY === lastScrollY) return;

      // Check if we're above the intersector based on scroll position
      const intersectorRect = headerIntersector.getBoundingClientRect();
      isAboveIntersector = intersectorRect.top > 0;

      // If we're above the intersector, always hide
      if (isAboveIntersector) {
        updateHeaderClasses(true);
      } else {
        // Below intersector: hide on scroll down, show on scroll up
        updateHeaderClasses(currentScrollY > lastScrollY);
      }

      lastScrollY = currentScrollY;
    }, 100);

    window.addEventListener('scroll', handleScroll, { passive: true });

    new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const wasAbove = isAboveIntersector;
        isAboveIntersector = entry.boundingClientRect.y > 0;

        // If we've crossed the intersection point, force an update
        if (wasAbove !== isAboveIntersector) {
          if (isAboveIntersector) {
            updateHeaderClasses(true); // Force hide when moving above
          } else {
            updateHeaderClasses(false); // Force show when moving below
          }
        }
      },
      { threshold: [0], rootMargin: '-1px 0px 0px 0px' }
    ).observe(headerIntersector);
  }

  initFeatureHeroObserver();

  function setupMobileMenu(containerClass: string, triggerClass: string) {
    const container = document.querySelector<HTMLButtonElement>(containerClass)!;
    const trigger = container.querySelector<HTMLButtonElement>(triggerClass)!;
    const menu = document.getElementById(trigger.getAttribute('aria-controls')!)!;

    // Setup main menu trigger
    trigger.addEventListener('click', () => {
      trigger.classList.toggle('open');
      const isOpen = trigger.classList.contains('open');
      isMenuOpen = isOpen; // Update the state
      trigger.ariaExpanded = isOpen ? 'true' : 'false';
      menu.classList.toggle('hidden');
    });

    // Setup dropdowns
    container.querySelectorAll('.js-mobile-dropdown').forEach((dropdown) => {
      const dropdownTrigger = dropdown.querySelector<HTMLButtonElement>(
        '.js-mobile-dropdown-trigger',
      )!;

      dropdownTrigger.addEventListener('click', () => {
        dropdown.classList.toggle('open');
        dropdownTrigger.ariaExpanded = dropdown.classList.contains('open') ? 'true' : 'false';
      });
    });
  }

  // Initialize both mobile menus
  setupMobileMenu('.mobile-nav', '.js-mobile-menu-trigger-mobile-nav');
  setupMobileMenu('.mobile-fixed-nav', '.js-mobile-menu-trigger-mobile-fixed-nav');
}
